import React from 'react';
import '../styles/footer.css'

const Footer = () => {
    return (
        <div className='footer'>
            <p>Create by Juan Carlos Maya Perdomo  </p>
            <div className='a-footer'>
                <a href="https://twitter.com/juancho94ify" target={'blank'}>
                    <i className="fa-brands fa-twitter"></i>
                </a>
                <a href="https://github.com/Js-focus" target={'blank'}>
                    <i className="fa-brands fa-github"></i>
                </a>
                <a href="https://www.linkedin.com/in/js-focus/" target={'blank'}>
                    <i className="fa-brands fa-linkedin-in"></i>
                </a>
            </div>
            
        </div>
    );
};

export default Footer;<p>Hecho con </p>